const iso2ToIso1Map: Record<string, string> = {
    ces: 'cs',
    eng: 'en',
    slk: 'sk',
    hun: 'hu',
    pol: 'pl',
    deu: 'de',
    fra: 'fr',
    ukr: 'uk',
    rus: 'ru',
}

const iso1ToIso2Map: { [key: string]: string } = Object.fromEntries(
    Object.entries(iso2ToIso1Map).map(([iso2, iso1]) => [iso1, iso2])
)

/**
 * Maps a language ISO 639-2 code to a ISO 639-1 code.
 * @param iso2 the ISO 639-2 code (e.g. 'eng')
 * @returns the ISO 639-1 code (e.g. 'en')
 */
export function mapLangIso2toIso1(iso2: string | null): string | null {
    return iso2 ? iso2ToIso1Map[iso2] ?? null : null
}

/**
 * Maps a language ISO 639-1 code to a ISO 639-2 code.
 * @param iso1 the ISO 639-1 code (e.g. 'en')
 * @returns the ISO 639-2 code (e.g. 'eng')
 */
export function mapLangIso1toIso2(iso1: string | null): string | null {
    return iso1 ? iso1ToIso2Map[iso1] ?? null : null
}
